import { Table, Menu, Dropdown, Icon, message, Button } from "antd";
import cloneDeep from "lodash/cloneDeep";
import WeaTools from "../../wea-tools";
const MenuItem = Menu.Item;
import isEmpty from "lodash/isEmpty";
import isArray from "lodash/isArray";
import isEqual from "lodash/isEqual";
import uniq from "lodash/uniq";
import uniqBy from "lodash/uniqBy";
import WeaLocaleProvider from "../../wea-locale-provider";
const getLabel = WeaLocaleProvider.getLabel;

//weaSimple:简单分页
//scroll : 启用内部滚动 false(默认)
//heightSpace : 启用内部滚动后高度调整 Number
//usePagination : 是否开启 table分页  true(默认)
//size : 正常或迷你类型，default(默认)、 small
//useFixedHeader : 是否固定表头 false(默认)
//bordered : 是否展示外边框和列边框 false(默认)
//showHeader : 是否显示表头 true(默认)
//useFilters : 使用过滤 false(默认)
//useSorter : 使用排序 true(默认)
//showCheck : 是否展示复选 默认 false(默认)
//checkType : checkbox(默认) OR radio
//noOperate : 不增加操作行 false(默认)
//refreshDatas : 是否触发table 接口 false(默认) 第一次触发之前,需要先传入一次datakey,每次触发接口需 false->true
//useLoading : 是否开启table 自身loading false(默认)
//---------pagination----------
//showSizeChanger : 显示分页大小选择 true(默认)
//showQuickJumper : 显示快速跳转 true(默认)
//showTotal : 显示总数量 true(默认)
//---------function----------
//onChange(pagination,filter,sorter) : 获取table操作 分页、排序、本地过滤、信息 (obj,obj,obj)
//getSelection(selectedRowKeys) : 获取选中行信息 (string)
//getTableLoading(bool) : 获取table 加载状态 (bool)
//onRowClick(record,index) : 行点击事件 (obj,number)

//国际化 zxt- 20170419
const defaultLocale = {
  total: "共",
  totalUnit: "条",
  operates: "操作",
  customColTitle: "定制列",
  customColSelect: "待选列名",
  customColSelected: "已选列名",
  customColSave: "保存",
  customColCancel: "取消"
};

class Main extends React.Component {
  //国际化 zxt- 20170419
  static contextTypes = {
    antLocale: React.PropTypes.object
  };
  getLocale() {
    let locale = {};
    if (this.context.antLocale && this.context.antLocale.Table) {
      locale = this.context.antLocale.WeaTable;
    }
    return { ...defaultLocale, ...locale, ...this.props.locale };
  }
  constructor(props) {
    super(props);
    this.instanceIsMounted = false;
    let columns = [];
    let datas = [];
    let selectedRowKeys = [];
    if (props.noSkHasPgTable) {
      columns = props.noSkHasPgTable.hasPgTableData.columns || [];
      datas = props.noSkHasPgTable.hasPgTableData.datas || [];
    }
    if (!isEmpty(props.noPgTableData)) {
      columns = props.noPgTableData.columns || [];
      datas = props.noPgTableData.datas;
    }
    if (!isEmpty(props.checkedDatas)) {
      props.checkedDatas.forEach(d => {
        selectedRowKeys.push(d.id);
      });
    }
    this.state = {
      height: props.scrollHeight || 0,
      showCheck: props.showCheck || false,
      columns: columns,
      datas: datas,
      operates: [],
      sortParams: [],
      selectedRowKeys: selectedRowKeys,
      current: 1,
      count: 0,
      pageSize: props.pageSize || 10,
      loading: false,
      showCheckedDatas: false,
      checkedDatas: props.checkedDatas || []
    };
  }
  setScrollheigth() {
    const { heightSpace } = this.props;
    let hs = heightSpace || 0;
    if (
      jQuery(".wea-browser-table") &&
      jQuery(".wea-browser-table .ant-pagination.ant-table-pagination")
    ) {
      let widowClientHeight = document.documentElement.clientHeight || 0;
      let top = jQuery(".wea-browser-table").offset()
        ? jQuery(".wea-browser-table").offset().top
        : 0;
      let bottom =
        jQuery(
          ".wea-browser-table .ant-pagination.ant-table-pagination"
        ).height() || 30;
      let scrollheigth = widowClientHeight - top - bottom;
      this.setState({
        height: scrollheigth - 100 - hs
      });
    }
  }
  componentDidMount() {
    this.instanceIsMounted = true;
    // console.log('weabrowsertable:props',this.props);
    const { usePagination, noPgTableData, dataKey } = this.props;
    // console.log('noPgTableData',noPgTableData);
    usePagination && this.getTableDatas(dataKey);
    this.setScrollheigth();
    window.addEventListener("resize", this.onWindowResize);
  }
  componentWillReceiveProps(nextProps, nextState) {
    if (this.props.showCheckedDatas !== nextProps.showCheckedDatas) {
      this.setState({ showCheckedDatas: nextProps.showCheckedDatas });
    }
    if (
      this.props.dataKey !== nextProps.dataKey &&
      !isEmpty(nextProps.dataKey)
    ) {
      this.getTableDatas(nextProps.dataKey);
    }
    if (!isEqual(this.props.noPgTableData, nextProps.noPgTableData)) {
      !isEmpty(nextProps.noPgTableData) &&
        this.setState({
          datas: nextProps.noPgTableData.datas,
          columns: nextProps.noPgTableData.columns
        });
    }
    if (
      "checkedDatas" in nextProps &&
      !isEqual(this.state.checkedDatas, nextProps.checkedDatas)
    ) {
      let keys = [],
        datas = [];
      isArray(nextProps.checkedDatas) &&
        nextProps.checkedDatas.forEach(d => {
          keys.push(d.randomFieldId || d.id);
          if (d.randomFieldId) datas.push(d);
        });
      this.setState({
        selectedRowKeys: keys,
        checkedDatas: nextProps.checkedDatas
      });
    }

    if (
      !WeaTools.isEqual(this.props.noSkHasPgTable, nextProps.noSkHasPgTable)
    ) {
      !isEmpty(nextProps.noSkHasPgTable) &&
        !isEmpty(nextProps.noSkHasPgTable.hasPgTableData) &&
        this.setState({
          current: 1,
          columns: nextProps.noSkHasPgTable.hasPgTableData.columns,
          datas: nextProps.noSkHasPgTable.hasPgTableData.datas,
          count: nextProps.noSkHasPgTable.hasPgTableData.count
        });
    }
    // console.log('Table---componentWillReceiveProps')
  }
  componentWillUnmount() {
    this.instanceIsMounted = false;
    window.removeEventListener("resize", this.onWindowResize);
  }
  onWindowResize = () => {
    this.instanceIsMounted && this.setScrollheigth();
  };
  // shouldComponentUpdate(nextProps,nextState) {
  //   return this.state.height !== nextState.height ||
  //     this.state.current !== nextState.current ||
  //     this.state.count !== nextState.count ||
  //     this.state.pageSize !== nextState.pageSize ||
  //     this.state.showCheck !== nextState.showCheck ||
  //     this.props.refreshDatas !== nextProps.refreshDatas ||
  //     this.props.dataKey !== nextProps.dataKey ||
  //     JSON.stringify(this.state.columns) !== JSON.stringify(nextState.columns) ||
  //     JSON.stringify(this.state.datas) !== JSON.stringify(nextState.datas) ||
  //     JSON.stringify(this.state.operates) !== JSON.stringify(nextState.operates) ||
  //     JSON.stringify(this.state.selectedRowKeys) !== JSON.stringify(nextState.selectedRowKeys) ||
  //     JSON.stringify(this.state.sortParams) !== JSON.stringify(nextState.sortParams) ||
  //     this.props.noPgTableData !== nextProps.noPgTableData ||
  //     this.props.noSkHasPgTable !== nextProps.noSkHasPgTable
  // }
  formatColumns(columns) {
    const {
      scrollx,
      showRadio,
      scroll,
      heightSpace,
      usePagination,
      size,
      useFixedHeader,
      bordered,
      showHeader,
      useFilters,
      useSorter,
      noOperate,
      checkType,
      useLoading,
      contentHeight
    } = this.props;
    const {
      height,
      datas,
      operates,
      selectedRowKeys,
      showCheck,
      loading,
      sortParams
    } = this.state;
    let newColumns = this.getColumns(columns) || [];
    let oldWidthObj = {};
    let num = 0;
    let nowWidth = 0;
    newColumns = newColumns.filter(newColumn => {
      if (newColumn.hide == "false" && newColumn.oldWidth) {
        const width = newColumn.oldWidth
          ? parseFloat(
              newColumn.oldWidth.substring(0, newColumn.oldWidth.length - 1)
            )
          : 10;
        oldWidthObj[newColumn.dataIndex] = width;
        num++;
        nowWidth += width;
      }
      return String(newColumn.hide) == "false";
    });
    !noOperate && newColumns.push(this.createOperate());
    nowWidth += 8; //操作按钮
    if (showCheck || showRadio) nowWidth += 2; //check框位置
    newColumns = newColumns.map(newColumn => {
      if (newColumn.hide == "false" && newColumn.oldWidth) {
        newColumn.width =
          parseFloat(oldWidthObj[newColumn.dataIndex]) +
          (100 - nowWidth) *
            parseFloat(oldWidthObj[newColumn.dataIndex] / nowWidth) +
          "%";
        if (scrollx) newColumn.width = newColumn.oldWidth;
        if (useSorter !== false && newColumn.orderkey) {
          newColumn.sorter = true;
          if (sortParams && sortParams.length > 0) {
            sortParams.map(s => {
              if (s.orderkey == newColumn.orderkey)
                newColumn.sortOrder = s.sortOrder;
            });
          } else {
            newColumn.sortOrder = false;
          }
        }
        return newColumn;
      }
      return newColumn;
    });
    return newColumns;
  }
  render() {
    const locale = this.getLocale();
    const {
      width,
      scrollx,
      showCheckBtn,
      showRadio,
      scroll,
      heightSpace,
      usePagination,
      size,
      useFixedHeader,
      bordered,
      showHeader,
      useFilters,
      useSorter,
      noOperate,
      checkType,
      useLoading,
      contentHeight,
      showCheckedDatasChange
    } = this.props;
    const {
      height,
      columns,
      datas,
      operates,
      selectedRowKeys,
      showCheck,
      loading,
      sortParams
    } = this.state;
    const { showCheckedDatas, checkedDatas } = this.state;
    let scrollHeight = {};
    if (scroll || width) {
      let s = {};
      if (scroll) s.y = height;
      if (width && scrollx) s.x = width - 20;
      if (width && scrollx && showCheck) s.x = s.x - 60;
      scrollHeight.scroll = s;
    }
    const newLoading = useLoading ? { loading: loading } : {};
    let newColumns = this.formatColumns(columns);
    let rowSelection = showCheck
      ? {
          selectedRowKeys: selectedRowKeys,
          onSelect: (record, selected, selectedRows) => {
            let { selectedRowKeys, checkedDatas = [] } = this.state;
            if (isEmpty(selectedRowKeys)) selectedRowKeys = [];
            if (selected) {
              selectedRowKeys.push(record.randomFieldId);
              checkedDatas.push(record);
            } else {
              selectedRowKeys = selectedRowKeys.filter(
                item => item !== record.randomFieldId
              );
              checkedDatas = checkedDatas.filter(
                item => (item.randomFieldId || item.id) !== record.randomFieldId
              );
            }
            this.setState({ selectedRowKeys, checkedDatas });
            this.props.getSelection &&
              this.props.getSelection(selectedRowKeys, checkedDatas);
          },
          onSelectAll: (selected, selectedRows, changeRows) => {
            let { selectedRowKeys, checkedDatas = [] } = this.state;
            if (isEmpty(selectedRowKeys)) selectedRowKeys = [];
            if (selected) {
              selectedRows.forEach(item =>
                selectedRowKeys.push(item.randomFieldId)
              );
              checkedDatas = checkedDatas.concat(changeRows);
              selectedRowKeys = uniq(selectedRowKeys);
            } else {
              selectedRowKeys = selectedRowKeys.filter(
                item => !changeRows.some(i => item === i.randomFieldId)
              );
              checkedDatas = checkedDatas.filter(
                item =>
                  !changeRows.some(
                    i => (item.randomFieldId || item.id) === i.randomFieldId
                  )
              );
            }
            this.setState({ selectedRowKeys, checkedDatas });
            this.props.getSelection &&
              this.props.getSelection(selectedRowKeys, checkedDatas);
          }
        }
      : null;
    if (showRadio) {
      rowSelection = {
        type: "radio",
        selectedRowKeys: selectedRowKeys,
        onSelect: (record, selected, selectedRows) => {
          let selectedRowKeys = [],
            checkedDatas = [];
          if (selected) {
            selectedRowKeys.push(record.randomFieldId);
            checkedDatas.push(record);
          }
          this.setState({ selectedRowKeys, checkedDatas });
          this.props.getSelection &&
            this.props.getSelection(selectedRowKeys, checkedDatas);
        }
      };
    }
    const checkedRowSelection = {
      selectedRowKeys: selectedRowKeys,
      onChange: (sRowKeys, sRows) => {
        this.setState({ selectedRowKeys: sRowKeys, checkedDatas: sRows });
        this.props.getSelection && this.props.getSelection(sRowKeys, sRows);
      }
    };
    const paginationConfig = usePagination
      ? { weaSimple: this.props.weaSimple, pagination: this.getPagination() }
      : { weaSimple: false, pagination: false };
    return (
      <div className="wea-new-table wea-browser-table">
        {showCheckBtn && (
          <span className="check-button-wrapper">
            <Button
              className="check-button"
              type={showCheckedDatas ? "primary" : "ghost"}
              onClick={() => {
                this.setState({ showCheckedDatas: !showCheckedDatas });
                showCheckedDatasChange &&
                  showCheckedDatasChange(!showCheckedDatas);
              }}
            >
              {getLabel(385596, "仅显示已选")}
            </Button>
            {showCheckedDatas && (
              <span className="icon-check-wrapper">
                <Icon className="icon-check" type="check" />
              </span>
            )}
          </span>
        )}
        {!showCheckedDatas ? (
          <Table
            {...scrollHeight}
            useFixedHeader={useFixedHeader}
            rowSelection={rowSelection}
            contentHeight={contentHeight}
            columns={newColumns}
            dataSource={datas}
            {...paginationConfig}
            checkType={checkType || "checkbox"}
            rowKey={record => record.randomFieldId} // randomFieldId row的标识，和后端协商改数据 和id 一样
            onRowClick={this.onRowClick.bind(this)}
            onChange={this.onChange.bind(this)}
          />
        ) : (
          <Table
            {...scrollHeight}
            useFixedHeader={useFixedHeader}
            rowSelection={checkedRowSelection}
            contentHeight={contentHeight}
            columns={newColumns}
            dataSource={checkedDatas}
            weaSimple={false}
            pagination={false}
            checkType={checkType || "checkbox"}
            rowKey={record => record.randomFieldId} // randomFieldId row的标识，和后端协商改数据 和id 一样
          />
        )}
      </div>
    );
  }
  getPagination() {
    //showSizeChanger 默认开启 true
    //showQuickJumper 默认开启 true
    //showTotal 默认开启 true
    const locale = this.getLocale();
    const {
      showSizeChanger,
      pageSizeOptions,
      showQuickJumper,
      pageinationSize,
      showTotal
    } = this.props;
    const { current, count, pageSize } = this.state;
    let obj = {
      defaultCurrent: 1,
      defaultPageSize: pageSize,
      current: current,
      count: count,
      total: count,
      showSizeChanger: showSizeChanger === false ? false : true,
      showQuickJumper: showQuickJumper === false ? false : true,
      pageSizeOptions: pageSizeOptions ? pageSizeOptions : [10, 20, 50, 100]
    };
    if (showTotal !== false) {
      obj.showTotal = total => {
        return getLabel(385617, "共$s条").replace(/\$s/, total);
      };
    }
    return obj;
  }
  getTableDatas(key, clear = true, c, p, s) {
    const { dataKey, noSkHasPgTable, keepSelectedRowKeys } = this.props;
    // console.log('noSkHasPgTable',noSkHasPgTable);
    const { current, pageSize, sortParams, count } = this.state;
    let newCurrent = c ? c : current;
    if (clear) newCurrent = 1; //页码回到1
    let newPageSize = p ? p : pageSize;
    let newSortParams = s ? s : sortParams;
    let newDataKey = key ? key : dataKey;

    let min = newPageSize * (newCurrent - 1) + 1;
    let max = newPageSize * newCurrent;
    //如需清除状态
    let newClear = clear == false ? clear : true;
    if (newClear) {
      min = 1;
      max = newPageSize;
      newSortParams = [];
      const newState = {
        current: 1,
        pageSize: pageSize,
        sortParams: [],
        selectedRowKeys: ""
      };
      // 保留选中的数据，防止被清除掉
      if (keepSelectedRowKeys) delete newState.selectedRowKeys;
      this.setState(newState);
    }
    if (typeof this.props.getTableLoading === "function")
      this.props.getTableLoading(true);
    if (noSkHasPgTable && noSkHasPgTable.contentType == "hasPgTable") {
      //没sessionkey有分页的数据
      // console.log('没sessionkey有分页的数据');
      if (c || p) {
        // console.log('分页改变调用-->noSkHasPgTable',noSkHasPgTable);
        let newUrl = noSkHasPgTable.url
          .replace(/&min=(\d)*/g, "")
          .replace(/&max=(\d)*/g, "");
        if (newCurrent > 1 && max > count) max = count;
        newUrl +=
          "&" +
          WeaTools.getFd({
            min: min,
            max: max,
            sortParams: JSON.stringify(newSortParams)
          });
        this.props.setLoading && this.props.setLoading(true);
        WeaTools.callApi(newUrl, "GET")
          .then(data => {
            this.setState({
              current: newCurrent,
              datas: data.datas,
              columns: data.columns,
              count: data.total,
              sortParams: newSortParams
            });
            this.props.setLoading && this.props.setLoading(false);
          })
          .catch(e => this.props.onError && this.props.onError(e));
      } else {
        // console.log('初始调用-->noSkHasPgTable',noSkHasPgTable);
        this.setState({
          current: current,
          columns: noSkHasPgTable.hasPgTableData.columns,
          datas: noSkHasPgTable.hasPgTableData.datas,
          count: noSkHasPgTable.hasPgTableData.count
        });
      }
    }
    if (!noSkHasPgTable && newDataKey) {
      //有sessionkey有分页的数据
      // console.log('有sessionkey有分页的数据');
      this.props.setLoading && this.props.setLoading(true);
      Promise.all([
        WeaTools.callApi("/api/ec/dev/table/datas", "POST", {
          dataKey: newDataKey,
          min: min,
          max: max,
          pageSize: pageSize,
          sortParams: JSON.stringify(newSortParams)
        }).then(data => {
          this.setState({
            current: newCurrent,
            datas: data.datas,
            columns: data.columns,
            operates: data.ops,
            // showCheck: data.haveCheck,
            sortParams: newSortParams
          });
          this.props.formatInput && this.props.formatInput(data.columns);
          if (data.count) {
            this.setState({
              count: data.count
            });
            if (typeof this.props.onChange === "function") {
              this.props.onChange({
                count: data.count,
                current: newCurrent,
                pageSize: newPageSize
              });
            }
          } else {
            WeaTools.callApi("/api/ec/dev/table/counts", "POST", {
              dataKey: newDataKey
            }).then(data => {
              this.setState({
                count: data.count
              });
              if (typeof this.props.onChange === "function") {
                this.props.onChange({
                  count: data.count,
                  current: newCurrent,
                  pageSize: newPageSize
                });
              }
              return data;
            });
          }
          return data;
        })
      ])
        .then(result => {
          const doCheckApi = result[0].haveCheck;
          const ops = result[0].ops;
          this.props.setLoading && this.props.setLoading(false);
          if (doCheckApi || (ops && ops.length > 0)) {
            const columns = result[0].columns;
            const checkDatas = result[0].datas;
            let newDatas = [];
            checkDatas.map(d => {
              let newData = {};
              columns.map(c => {
                if (
                  (c.from && c.from === "set") ||
                  c.dataIndex === "randomFieldId"
                )
                  newData[c.dataIndex] = d[c.dataIndex];
              });
              newDatas.push(newData);
            });
            WeaTools.callApi("/api/ec/dev/table/checks", "POST", {
              randomDatas: JSON.stringify(newDatas),
              dataKey: dataKey
            }).then(data => {
              let datas = this.state.datas;
              let nDatas = data.datas;
              datas = datas.map(d => {
                let newN = cloneDeep(d);
                nDatas.map(n => {
                  if (n.randomFieldId == d.randomFieldId) {
                    for (let p in n) {
                      newN[p] = n[p];
                    }
                  }
                });
                return newN;
              });
              this.setState({ datas: datas });
              if (typeof this.props.getTableLoading === "function")
                this.props.getTableLoading(false);
            });
          }
        })
        .catch(e => this.props.onError && this.props.onError(e));
    }
  }
  onChange(pagination, filters, sorter) {
    let params = {
      current: pagination.current,
      pageSize: pagination.pageSize,
      sortParams: sorter.column
        ? [{ orderkey: sorter.column.orderkey, sortOrder: sorter.order }]
        : []
    };
    // this.setState(params)
    this.getTableDatas(
      "",
      false,
      params.current,
      params.pageSize,
      params.sortParams
    );
  }
  onRowClick(record, index) {
    if (typeof this.props.onRowClick === "function")
      this.props.onRowClick(record, index);
  }
  getColumns(columns) {
    let newColumns = cloneDeep(columns);
    return (
      newColumns &&
      newColumns.map(column => {
        let newColumn = column;
        newColumn.render = (text, record, index) => {
          //前端元素转义
          let valueSpan = record[newColumn.dataIndex + "span"];
          if (undefined === valueSpan) {
            valueSpan = record[newColumn.dataIndex];
          }
          // let valueSpan = record[newColumn.dataIndex + "span"];
          function createMarkup() {
            return { __html: valueSpan };
          }
          return (
            <div className="wea-url" dangerouslySetInnerHTML={createMarkup()} />
          );
        };
        // console.log('newColumns',newColumns)
        return newColumn;
      })
    );
  }
  createOperateDom = (opers, operText) => {
    if (!Array.isArray(opers) || opers.length == 0) return <div />;
    return (
      <div
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          if (e.nativeEvent.stopImmediatePropagation) {
            e.nativeEvent.stopImmediatePropagation();
          }
          if (e.nativeEvent.preventDefault) {
            e.nativeEvent.preventDefault();
          }
        }}
      >
        <Dropdown
          getPopupContainer={triggerNode => {
            return triggerNode;
          }}
          overlay={
            <Menu>
              {opers.map((oper, index) => {
                return (
                  <MenuItem key={index}>
                    <a
                      href="javascript:void(0);"
                      onClick={e => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (e.nativeEvent.stopImmediatePropagation) {
                          e.nativeEvent.stopImmediatePropagation();
                        }
                        if (e.nativeEvent.preventDefault) {
                          e.nativeEvent.preventDefault();
                        }
                        oper.func();
                      }}
                    >
                      {oper.text}
                    </a>
                  </MenuItem>
                );
              })}
            </Menu>
          }
        >
          <a className="ant-dropdown-link" href="javascript:void(0);">
            {operText} <Icon type="caret-down" />
          </a>
        </Dropdown>
      </div>
    );
  };

  createOperate = () => {
    return {
      title: "",
      dataIndex: "randomFieldOperate",
      key: "randomFieldOperate",
      className: "wea-table-operates",
      display: "true",
      render: this.createOperateRender()
    };
  };
  createOperateRender = (createOperateDom = this.createOperateDom) => {
    const { operates } = this.state;
    const locale = this.getLocale();
    return (text, record, index) => {
      const rfs = record.randomFieldOp
        ? typeof record.randomFieldOp === "object"
          ? record.randomFieldOp
          : JSON.parse(record.randomFieldOp)
        : "";

      let operList = operates
        .filter((oper, operIndex) => {
          let flag = oper.index || "-1";
          // 支持rfs为true或false时直接返回
          if (rfs === true || rfs === false) {
            return rfs;
          } else if (rfs === "true" || rfs === "false" || rfs === "") {
            // 后端虽然已做了为空判断，但为空时还是要判断为false，处理初始化时权限全部放开的问题
            return rfs === "true";
          } else {
            return rfs[flag] && rfs[flag] != "false";
          }
        })
        .map((operate, operIndex) => {
          let flag = operate.index || "-1";
          let argumentString = [];
          let opParams = record["randomFieldOpPara" + (operate.index || "")];
          Array.isArray(opParams) &&
            opParams.map(r => {
              argumentString.push(r.obj);
            });
          // 旧的操作方法
          let fn = this.createOperateOldFunc(
            operate.href,
            record,
            argumentString
          );
          return {
            text: operate.text,
            func: () => {
              typeof this.props.onOperatesClick === "function"
                ? this.props.onOperatesClick(record, index, operate, flag)
                : eval(fn);
            }
          };
        });
      return createOperateDom(
        operList,
        getLabel(30585, "操作"),
        record,
        index,
        operates
      );
    };
  };
  createOperateOldFunc = (href, record, argumentString) => {
    let fn = "";
    if (href) {
      fn = href.split(":")[1].split(")")[0];
      if (typeof record.randomFieldId === "number") fn += record.randomFieldId;
      if (typeof record.randomFieldId === "string")
        fn += '"' + record.randomFieldId + '"';
      if (argumentString.length && argumentString.length > 0) {
        fn += ",";
        argumentString.map(a => {
          if (typeof record.randomFieldId === "number") fn += a;
          if (typeof record.randomFieldId === "string") fn += '"' + a + '"';
        });
      }
      fn += ")";
    }
    return fn;
  };
}

export default Main;



// WEBPACK FOOTER //
// ./ecology9/wea-browser-test/components/WeaBrowserTable.js